import Parse from "parse";

import type { Kanban_State } from "./Kanban_State";
import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_Kanban_StateAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  state: Kanban_State;
  tenant?: OD3_Tenant;
  ticket: Ticket;
  user?: _User;
}

export class Ticket_Kanban_State extends Parse.Object<Ticket_Kanban_StateAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Kanban_State";

  constructor(data?: Partial<Ticket_Kanban_StateAttributes>) {
    super("OD3_Maintenance_Ticket_Kanban_State", data as Ticket_Kanban_StateAttributes);
  }

  get state(): Kanban_State {
    return super.get("state");
  }
  set state(value: Kanban_State) {
    super.set("state", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Kanban_State", Ticket_Kanban_State);
